import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRounded: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRounded"><Path fillRule="evenodd" clipRule="evenodd" d="M16.5 3.08594L21.4142 8.00015L16.5 12.9144L15.0858 11.5002L17.5858 9.00015H13C10.7909 9.00015 9 10.791 9 13.0002V15.0002H7V13.0002C7 9.68644 9.68629 7.00015 13 7.00015H17.5858L15.0858 4.50015L16.5 3.08594ZM4 7.00015V18.0002H20V20.0002H2V7.00015H4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRounded;
